import { render, staticRenderFns } from "./PlaidButton.vue?vue&type=template&id=6aedf2d4&scoped=true&"
import script from "./PlaidButton.vue?vue&type=script&lang=ts&"
export * from "./PlaidButton.vue?vue&type=script&lang=ts&"
import style0 from "./PlaidButton.vue?vue&type=style&index=0&id=6aedf2d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aedf2d4",
  null
  
)

export default component.exports